document.addEventListener('DOMContentLoaded', () => {
  (() => {
    // ---------- DOM helpers ----------
    function drawer() { return document.querySelector('#cart-drawer') || document.body; }
    function container() { return drawer().querySelector('#free-shipping-container'); }
    function valueEl()    { return drawer().querySelector('#free-shipping-value-cart2'); }
    function statusNode() { return drawer().querySelector('.js-shipping-drawer'); }
    function fillEl()     { return drawer().querySelector('#free-shipping-container .progress-fill') || null; }

    // ---------- One-time init per container ----------
    function initFor(el) {
      if (!el || el.dataset.fsInited === '1') return;
      el.dataset.fsInited = '1'; // guard: don’t init twice

      // Immediately hide to prevent showing server text before first render
      const reveal = () => { el.style.visibility = ''; };
      el.style.visibility = 'hidden';

      // ---- Read base from Liquid ----
      const BASE_AMOUNT = parseFloat(el.getAttribute('data-fs-base-amount') || '0'); // whole units
      const BASE_CCY    = (el.getAttribute('data-fs-base-currency') || '').toUpperCase();
      if (!BASE_AMOUNT || !BASE_CCY) return;

      // ---- Active currency ----
      const ctx = window.__CART_CTX || {};
      let ACTIVE_CCY = ctx.currency || window.Shopify?.currency?.active || '';
      if (!ACTIVE_CCY) ACTIVE_CCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';

      // ---- Local state to avoid races + cache thresholds ----
      let renderSeq = 0;
      const thresholdCache = new Map(); // key: currency, value: cents

      // ---- Helpers ----
      function setProgress(p) {
        const bar = fillEl();
        if (!bar) return;
        const clamped = Math.max(0, Math.min(100, Math.floor(p)));
        bar.style.width = clamped + '%';
        if (clamped >= 100) bar.classList.add('free_shipping'); else bar.classList.remove('free_shipping');
      }
      function render(diffCents, thresholdCents, cartCents) {
        if (cartCents >= thresholdCents) {
          const n = statusNode();
          if (n) n.outerHTML = `<span class="js-shipping-drawer free">${window.__FREE_SHIP_MSG_3 || 'Free shipping reached'}</span>`;
          setProgress(100);
          return;
        }
        const fmt = (cents) => {
          try {
            if (window.Shopify && typeof Shopify.formatMoney === 'function') return Shopify.formatMoney(Math.round(cents));
          } catch(_) {}
          const amount = (Math.round(cents) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          return `${amount} ${ACTIVE_CCY}`;
        };
        const v = valueEl();
        const diffText = fmt(diffCents);
        if (v) v.textContent = diffText;

        const pct = thresholdCents > 0 ? (cartCents * 100) / thresholdCents : 0;
        setProgress(pct);
      }

      function computeThresholdCents() {
        // Use cache if available
        const cached = thresholdCache.get(ACTIVE_CCY);
        if (typeof cached === 'number') return cached;

        if (ACTIVE_CCY === BASE_CCY) {
          const whole = Math.ceil(BASE_AMOUNT);
          const cents = whole * 100;
          thresholdCache.set(ACTIVE_CCY, cents);
          return cents;
        }
        const url = `https://api.exchangerate-api.com/v4/latest/${encodeURIComponent(BASE_CCY)}`;
        return fetch(url)
          .then(r => { if (!r.ok) throw new Error('rate fetch'); return r.json(); })
          .then(data => {
            const rate = data && data.rates ? data.rates[ACTIVE_CCY] : null;
            if (!rate) throw new Error('missing rate ' + ACTIVE_CCY);
            const whole = Math.ceil(BASE_AMOUNT * rate);
            const cents = whole * 100;
            thresholdCache.set(ACTIVE_CCY, cents);
            return cents;
          });
      }

      function getCart() {
        return fetch('/cart.js').then(r => r.json()).catch(() => ({ total_price: 0 }));
      }

      function runOnce() {
        const mySeq = ++renderSeq;           // capture a sequence number
        el.style.visibility = 'hidden';      // hide while we compute to prevent flicker

        const maybe = computeThresholdCents();
        const apply = (thr) => getCart().then(cart => {
          // If another render started, drop this one
          if (mySeq !== renderSeq) return;

          const cartCents = +cart.total_price || 0;
          const diff = Math.max(0, thr - cartCents);
          render(diff, thr, cartCents);

          // Reveal only after DOM is updated by render()
          reveal();
        });

        if (typeof maybe === 'number') {
          apply(maybe);
        } else {
          maybe.then(apply).catch(() => {
            // If rates fail, keep server text hidden? Better to reveal to avoid blank UI.
            reveal();
          });
        }
      }

      // initial render now that container exists
      runOnce();

      // Re-render on AJAX cart updates (single source of truth)
      const rerender = () => {
        // console.log('[ajaxCart:updated] event detected');
        runOnce();
      };
      document.addEventListener('ajaxCart:updated', rerender, { passive: true });
    }

    // Try immediately if container already present
    initFor(container());

    // If not present yet, watch for it being injected later
    const waitForContainer = new MutationObserver(() => {
      const el = container();
      if (el && el.dataset.fsInited !== '1') initFor(el);
    });
    waitForContainer.observe(document.documentElement, { childList: true, subtree: true });
  })();
});
